import React from "react";
import { Phone, MapPin, Clock, Truck, ShieldCheck, Navigation } from "lucide-react";
import { restaurant } from "../mock/menuData";

const Contact = () => {
  return (
    <div className="brick-bg min-h-screen pt-24 pb-20">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <span className="font-script text-4xl text-pink">Nous trouver</span>
          <h1 className="font-display text-4xl md:text-5xl uppercase text-white mt-1">Contact & Horaires</h1>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-4">
            <div className="bg-[#141414] border border-white/10 rounded-2xl p-6">
              <h2 className="font-display text-2xl uppercase text-gold mb-4">Le snack</h2>
              <ul className="space-y-4 text-white/80">
                <li className="flex items-start gap-3"><MapPin className="text-pink shrink-0 mt-0.5" size={20} /> {restaurant.address}</li>
                <li className="flex items-center gap-3"><Phone className="text-pink shrink-0" size={20} /> <a href={`tel:${restaurant.phone.replace(/\s/g, "")}`} className="hover:text-gold">{restaurant.phone}</a></li>
                <li className="flex items-center gap-3"><Truck className="text-pink shrink-0" size={20} /> Livraison gratuite dès {restaurant.freeDeliveryFrom}€</li>
                <li className="flex items-center gap-3"><ShieldCheck className="text-pink shrink-0" size={20} /> Établissement 100% Halal</li>
              </ul>
              <a href="https://maps.google.com/?cid=7498489275777342015" target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 bg-pink text-white font-display uppercase px-6 py-2.5 rounded-full btn-shine">
                <Navigation size={18} /> Itinéraire
              </a>
            </div>

            <div className="bg-[#141414] border border-white/10 rounded-2xl p-6">
              <h2 className="font-display text-2xl uppercase text-gold mb-4 flex items-center gap-2"><Clock size={22} /> Horaires</h2>
              <ul className="divide-y divide-white/10">
                {restaurant.hours.map((h) => (
                  <li key={h.day} className="flex justify-between py-3">
                    <span className="text-white">{h.day}</span>
                    <span className="text-white/70">{h.time}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-4 flex flex-wrap gap-2">
                {restaurant.platforms.map((p) => (
                  <span key={p} className="bg-white/10 border border-white/15 rounded-lg px-3 py-1.5 text-sm text-white/80">{p}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden border border-white/10 min-h-[420px]">
            <iframe
              title="Carte M.Plaisir Marseille"
              src="https://www.google.com/maps?q=110+Boulevard+Saint+Marcel+13011+Marseille&output=embed"
              className="w-full h-full min-h-[420px]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
